import { ICommonIconProps } from './types';
/**
 * -----------------------------------------------------------------------------
 * It renders a delivery truck icon with a clock on top.
 */
export function DeliveryClockIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M15 8h4.323c.409 0 .777.249.928.629l1.606 4.014c.094.236.143.488.143.742v5.948a1 1 0 0 1-1 1h-1.831M16 20.42H8.17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M22 15h-4v-4h3.2M12.556 6H14a1 1 0 0 1 1 1v9H2"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        clipRule="evenodd"
        d="M7.739 2.05c-1.751.268-3.183 1.7-3.451 3.45a4.164 4.164 0 0 0 4.766 4.767c1.751-.268 3.183-1.7 3.451-3.451A4.164 4.164 0 0 0 7.739 2.05Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M18.704 19.296a1.584 1.584 0 1 1-2.24 2.24 1.584 1.584 0 0 1 2.24-2.24M7.704 19.296a1.584 1.584 0 1 1-2.24 2.24 1.584 1.584 0 0 1 2.24-2.24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="M5 20.416H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.238M10 6H8V4.159"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
